import gql from 'graphql-tag';
import { TAG_FRAGMENT } from '../../fragments/tag.fragment';

export const QUERY_LINKS_TABLE = gql`
  query linksTable {
    links: videoLinks {
      id
      authors {
        name
      }
      content {
        title
        language
      }
      tags {
        ...TagData
      }
    }
  }
  ${TAG_FRAGMENT}
`;
